import { createApiV2 } from "./common";

export const getSalesOrder = (payload) => (token) =>
  createApiV2("POST", `orders/search_orders/`)(token, payload);

export const postSalesOrderToggleColumn = (payload) => (token) =>
  createApiV2("POST", `orders/search_order_ids/`)(token, payload);

export const postDuplicateOrder =
  ({ customerUid, orderUid }) =>
  (token) =>
    createApiV2("POST", `customers/${customerUid}/orders/${orderUid}/duplicate/`)(token);

export const patchUpdateOrder =
  ({ customerUid, orderUid, payload }) =>
  (token) =>
    createApiV2("PATCH", `customers/${customerUid}/orders/${orderUid}/`)(token, payload);

export const patchUpdateOrderFromCustomColumn =
  ({ customerUid, orderUid, payload }) =>
  (token) =>
    createApiV2("PATCH", `customers/${customerUid}/orders/${orderUid}/custom_fields/`)(
      token,
      payload
    );

export const deleteOrder =
  ({ customerUid, orderUid }) =>
  (token) =>
    createApiV2("DELETE", `customers/${customerUid}/orders/${orderUid}/`)(token);

export const unDeleteOrder =
  ({ customerUid, orderUid }) =>
  (token) =>
    createApiV2("PATCH", `customers/${customerUid}/orders/${orderUid}/undestroy/`)(token);

export const moveWorkflowOrder = (payload) => (token) =>
  createApiV2("POST", "workflow/move_order/")(token, payload);

export const changeWorkflowOrder = (payload) => (token) =>
  createApiV2("POST", "workflow/change_order/")(token, payload);

export const exportToFile = (payload) => (token) =>
  createApiV2("POST", "orders/export/")(token, payload);

export const patchRequiredDate =
  ({ customerUid, orderUid, requiredDate }) =>
  (token) =>
    createApiV2("PATCH", `customers/${customerUid}/orders/${orderUid}/required-date/`)(token, {
      required_date: requiredDate,
    });

export default {};
